
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { SparkVisionSetting, Select } from '@/models/Configurator';

@Component
export default class ConfigView extends Vue {
    @Prop() configSelects!: Array<Select>;
    @Prop() sparkVisionSetting!: SparkVisionSetting;
    @Prop() dummyImage!: string;
    @Prop({ default: false }) isSticky!: boolean;

    private imageLoaded: boolean = true;
    private showMinimizeButton: boolean = false;
    private isMinimized: boolean = false;
    private studioPath: string = this.sparkVisionSetting.baseUrl;
    private stuidoParams: any = {
        strict: false,
        shadows: false,
        background: false,
        enc_type: 'simple',
        encoded_config: 'BallingslovStudio_Set01;'
    };

    constructor() {
        super();
    }

    @Watch('isSticky')
    onStickyChange(val: boolean) {
        if (val) {
            this.showMinimizeButton = true;
        } else if (!this.isMinimized) {
            this.showMinimizeButton = false;
        }
    }

    private toggleMinimized() {
        this.isMinimized = !this.isMinimized;
        
        if (!this.isMinimized && !this.isSticky) {
            this.showMinimizeButton = false;
        }
    }

    private cropping: string =
        '&cropped_width=' +
        this.sparkVisionSetting.croppedWidth +
        '&cropped_height=' +
        this.sparkVisionSetting.croppedHeight +
        '&crop_y_ratio=' +
        this.sparkVisionSetting.croppedYRatio +
        '&crop_x_ratio=' +
        this.sparkVisionSetting.croppedXRatio;

    get imageBaseUrl(): string {
        const qs = Object.keys(this.stuidoParams)
            .map((key: any) => `${key}=${this.stuidoParams[key]}`)
            .join('&');
        return this.studioPath + 'get_image_from_encoded_string?' + qs;
    }

    get configImageSrc(): string {
        this.imageLoaded = true;
        if (typeof this.configSelects !== 'undefined') {
            let text = '';
            for (const select of this.configSelects) {
                if (select.showInSparkVision) {
                    if (select.selectedOption.length) {
                        text += select.selectedOption[0].navisionId + ',';
                    } else if (select.hiddenId) {
                        text += select.hiddenId + ',';
                    }
                }
            }
            return this.imageBaseUrl + text + this.cropping;
        }
        return this.imageBaseUrl + 'No options selected';
    }
}
